import { cn } from '@virginexperiencedays/tailwind';

import {
  PromoCard as BasePromoCard,
  PromoCardText,
  PromoCardTextHighlight,
  PromoCardTitle as BasePromoCardTitle,
  type PromoCardProps,
} from '@virginexperiencedays/components-v2/src/cards/PromoCard';
import { IconBlackText } from '@virginexperiencedays/components-v2/src/icons/IconBlackFriday';
import { IconCyberText } from '@virginexperiencedays/components-v2/src/icons/IconCyberMonday';

import type { HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLDivElement> & {
  percentOff: number;
  promo: string;
};

export const PromoCardWidget = ({ promo, percentOff, ...rest }: Props) => {
  if (!percentOff) return null;

  // known promos
  const promos = ['black-friday', 'cyber-monday'];

  if (!promos.includes(promo)) return null;

  return (
    <BasePromoCard promo={promo as PromoCardProps['promo']} {...rest}>
      <PromoCardText>
        <PromoIconText promo={promo} />
        <PromoCardTitle promo={promo} className="mr-2" />
        <span className="mt-2 block md:mt-0 md:inline">
          Save big with <PromoCardTextHighlight>{percentOff}% off</PromoCardTextHighlight> this
          experience
        </span>
      </PromoCardText>
    </BasePromoCard>
  );
};

export const PromoIconText = ({ className, promo }: Pick<Props, 'className' | 'promo'>) => {
  const props = {
    className: cn('m-[-14px_4px_-8px_-8px] inline-block', className),
    viewBox: '7 7 75 31',
    width: '75',
    height: '31',
  };

  switch (promo) {
    case 'black-friday':
      return <IconBlackText {...props} />;
    case 'cyber-monday':
      return <IconCyberText {...props} />;
    default:
      return null;
  }
};

export const PromoCardTitle = ({ className, promo }: Pick<Props, 'className' | 'promo'>) => {
  const titles = {
    default: 'Deal',
    'black-friday': 'Friday Deal',
    'cyber-monday': 'Monday Deal',
  };

  return (
    <BasePromoCardTitle className={className}>
      {titles?.[promo] || titles.default}
    </BasePromoCardTitle>
  );
};
